import * as Icon from "react-bootstrap-icons";
import dlexit from "../../assets/img/dlexit.png";

const SidebarData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <Icon.House />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "User",
    path: "/User",
    icon: <Icon.Person />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Link",
    path: "/Link",
    icon: <img alt="game" src={dlexit} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Logout",
    path: "#", // Fallback path for logout
    icon: <Icon.BoxArrowRight />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
];

export default SidebarData;